import { ResaleStatuses } from "@generated/graphql";

export const RESALE_STATUS_SORT_ORDER = {
    [ResaleStatuses.PROVISIONALLY_ELIGIBLE]: 1,
    [ResaleStatuses.CONFIRMED_ELIGIBLE]: 2,
    [ResaleStatuses.RESEARCH_REQUIRED]: 3,
    [ResaleStatuses.OPTED_OUT]: 4,
    [ResaleStatuses.PROVISIONALLY_INELIGIBLE]: 5,
    [ResaleStatuses.CONFIRMED_INELIGIBLE]: 6,
    [ResaleStatuses.INVALID]: 7,
    [ResaleStatuses.RETURNED]: 8,
    [ResaleStatuses.CLOSED]: 9,
};